/** Teks kartu "Pemakaian AI" (plafon AI C1, rancangan 06c) di /admin/ai-assistant. */
export interface AssistantUsageText {
	title: string;
	intro: string;
	modeNote: string;
	relationNote: string;
	chat: string;
	voice: string;
	today: string;
	month: string;
	unlimited: string;
	usedOfLimit: (used: string, limit: string) => string;
	usedOnly: (used: string) => string;
	requests: (n: number) => string;
	noUsageNote: (n: number) => string;
	usdEstimate: (usd: string) => string;
	usdIncomplete: string;
	usdNone: string;
	resetDay: (when: string) => string;
	resetMonth: (when: string) => string;
	warnTitle: (percent: number) => string;
	warnLine: (meter: string, percent: number) => string;
	fullLine: (meter: string) => string;
	modelsTitle: string;
	colModel: string;
	colType: string;
	colInput: string;
	colOutput: string;
	colMinutes: string;
	colRequests: string;
	colUsd: string;
	rateMissing: string;
	modelsEmpty: string;
	chartTitle: string;
	chartTokens: string;
	chartMinutes: string;
	chartLimitLine: string;
	ratesTitle: string;
	ratesHint: string;
	ratePerMinute: string;
	rateInputMTok: string;
	rateOutputMTok: string;
	rateSave: string;
	rateSaved: string;
	rateIncomplete: string;
	rateUnset: string;
	rateDescVoice: string;
	rateDescChat: string;
	rateDescMock: string;
	rateDescUnknown: string;
	loadFailed: string;
	reload: string;
	settingsTitle: string;
	settingsIntro: string;
	warnPercentLabel: string;
	warnPercentHint: string;
	zeroUnlimited: string;
	chatTokenMonthly: string;
	voiceMinDaily: string;
	voiceMinMonthly: string;
	chatUsdDaily: string;
	chatUsdMonthly: string;
	voiceUsdDaily: string;
	voiceUsdMonthly: string;
}

const id: AssistantUsageText = {
	title: "Pemakaian AI",
	intro:
		"Pemakaian Claude (token) dan Suara (menit) hari ini dan bulan ini, dihitung per hari kalender WITA dari buku catatan pemakaian. Angka dolar hanya perkiraan dari tarif yang Anda isi.",
	modeNote:
		"Mode pantau: batas di bawah baru ditampilkan sebagai peringatan dan belum memblokir siapa pun.",
	relationNote:
		"Angka token di sini memuat semua panggilan model, termasuk yang gagal atau dibatalkan. Batas “Token Claude per hari (semua user)” di Batas pemakaian menghitung dari pesan yang tersimpan, jadi selisih kecil di antara keduanya wajar.",
	chat: "Chat Claude (token)",
	voice: "Suara (menit)",
	today: "Hari ini",
	month: "Bulan ini",
	unlimited: "tanpa batas",
	usedOfLimit: (used, limit) => `${used} dari ${limit}`,
	usedOnly: (used) => `${used} dipakai`,
	requests: (n) => `${n.toLocaleString("id-ID")} permintaan`,
	noUsageNote: (n) =>
		`${n.toLocaleString("id-ID")} panggilan tanpa laporan token dari penyedia (tidak terhitung)`,
	usdEstimate: (usd) => `≈ US$ ${usd} (estimasi)`,
	usdIncomplete: "Estimasi belum lengkap: ada model tanpa tarif.",
	usdNone: "Estimasi dolar belum tersedia: isi tarif model.",
	resetDay: (when) => `Reset hari ini ${when} lagi (00:00 WITA)`,
	resetMonth: (when) => `Reset bulan ini ${when} lagi`,
	warnTitle: (percent) => `Pemakaian AI mendekati batas (≥ ${percent}%)`,
	warnLine: (meter, percent) => `${meter}: ${percent}% dari batas`,
	fullLine: (meter) => `${meter}: batas sudah terlampaui`,
	modelsTitle: "Rincian per model",
	colModel: "Model",
	colType: "Jenis",
	colInput: "Token masuk",
	colOutput: "Token keluar",
	colMinutes: "Menit",
	colRequests: "Permintaan",
	colUsd: "Estimasi US$",
	rateMissing: "tarif belum diisi",
	modelsEmpty: "Belum ada pemakaian pada periode ini.",
	chartTitle: "14 hari terakhir",
	chartTokens: "Token Claude",
	chartMinutes: "Menit suara",
	chartLimitLine: "Batas harian",
	ratesTitle: "Tarif model (untuk estimasi dolar)",
	ratesHint:
		"Tarif Claude lewat proxy tidak diketahui sistem, isi sendiri (US$ per 1 juta token). Suara GPT-Live sudah terisi US$ 0,05 per menit.",
	ratePerMinute: "US$ per menit",
	rateInputMTok: "US$ per 1 jt token masuk",
	rateOutputMTok: "US$ per 1 jt token keluar",
	rateSave: "Simpan tarif",
	rateSaved: "Tarif tersimpan",
	rateIncomplete: "Isi tarif masuk dan keluar sekaligus",
	rateUnset: "belum diisi",
	rateDescVoice: "Dihitung per menit sesi suara.",
	rateDescChat: "Dihitung per 1 juta token masuk dan keluar.",
	rateDescMock: "Provider tiruan untuk uji coba, bukan tagihan sungguhan.",
	rateDescUnknown:
		"Sesi suara lama sebelum model dicatat. Isi tarif sama dengan model suara aktif agar dolarnya terhitung.",
	loadFailed: "Pemakaian AI tidak dapat dimuat.",
	reload: "Muat ulang",
	settingsTitle: "Plafon AI (mode pantau)",
	settingsIntro:
		"Batas hanya disimpan dan ditampilkan di kartu Pemakaian AI; belum memblokir. 0 = tanpa batas. Mengubah batas langsung berlaku di tampilan.",
	warnPercentLabel: "Ambang peringatan (%)",
	warnPercentHint: "Banner peringatan muncul untuk admin mulai ambang ini",
	zeroUnlimited: "0 = tanpa batas",
	chatTokenMonthly: "Token Claude per bulan",
	voiceMinDaily: "Menit suara per hari",
	voiceMinMonthly: "Menit suara per bulan",
	chatUsdDaily: "Dolar chat per hari (US$)",
	chatUsdMonthly: "Dolar chat per bulan (US$)",
	voiceUsdDaily: "Dolar suara per hari (US$)",
	voiceUsdMonthly: "Dolar suara per bulan (US$)",
};

const en: AssistantUsageText = {
	title: "AI usage",
	intro:
		"Claude (tokens) and Voice (minutes) usage for today and this month, counted per WITA calendar day from the usage ledger. Dollar figures are only estimates from the rates you enter.",
	modeNote:
		"Monitor mode: the limits below are only shown as warnings and do not block anyone yet.",
	relationNote:
		"Token numbers here include every model call, including failed or cancelled ones. The “Claude tokens per day (all users)” limit under Usage limits counts from stored messages, so a small difference between the two is expected.",
	chat: "Claude chat (tokens)",
	voice: "Voice (minutes)",
	today: "Today",
	month: "This month",
	unlimited: "unlimited",
	usedOfLimit: (used, limit) => `${used} of ${limit}`,
	usedOnly: (used) => `${used} used`,
	requests: (n) => `${n.toLocaleString("en-US")} requests`,
	noUsageNote: (n) =>
		`${n.toLocaleString("en-US")} calls without a token report from the provider (not counted)`,
	usdEstimate: (usd) => `≈ US$ ${usd} (estimate)`,
	usdIncomplete: "Estimate is incomplete: some models have no rate.",
	usdNone: "No dollar estimate yet: enter model rates.",
	resetDay: (when) => `Resets in ${when} (00:00 WITA)`,
	resetMonth: (when) => `Month resets in ${when}`,
	warnTitle: (percent) => `AI usage is near its limit (≥ ${percent}%)`,
	warnLine: (meter, percent) => `${meter}: ${percent}% of limit`,
	fullLine: (meter) => `${meter}: limit exceeded`,
	modelsTitle: "Breakdown per model",
	colModel: "Model",
	colType: "Type",
	colInput: "Input tokens",
	colOutput: "Output tokens",
	colMinutes: "Minutes",
	colRequests: "Requests",
	colUsd: "Estimated US$",
	rateMissing: "rate not set",
	modelsEmpty: "No usage in this period yet.",
	chartTitle: "Last 14 days",
	chartTokens: "Claude tokens",
	chartMinutes: "Voice minutes",
	chartLimitLine: "Daily limit",
	ratesTitle: "Model rates (for dollar estimates)",
	ratesHint:
		"The system does not know Claude rates through the proxy; enter them yourself (US$ per 1 million tokens). GPT-Live voice is pre-filled at US$ 0.05 per minute.",
	ratePerMinute: "US$ per minute",
	rateInputMTok: "US$ per 1M input tokens",
	rateOutputMTok: "US$ per 1M output tokens",
	rateSave: "Save rate",
	rateSaved: "Rate saved",
	rateIncomplete: "Fill in both input and output rates",
	rateUnset: "not set",
	rateDescVoice: "Billed per minute of voice session.",
	rateDescChat: "Billed per 1 million input and output tokens.",
	rateDescMock: "Fake provider for testing, not a real bill.",
	rateDescUnknown:
		"Older voice sessions from before the model was recorded. Set the same rate as the active voice model so the dollar estimate counts them.",
	loadFailed: "AI usage could not be loaded.",
	reload: "Reload",
	settingsTitle: "AI caps (monitor mode)",
	settingsIntro:
		"Limits are only stored and shown on the AI usage card; they do not block yet. 0 = unlimited. Changing a limit applies to the display immediately.",
	warnPercentLabel: "Warning threshold (%)",
	warnPercentHint: "The warning banner appears for admins from this threshold",
	zeroUnlimited: "0 = unlimited",
	chatTokenMonthly: "Claude tokens per month",
	voiceMinDaily: "Voice minutes per day",
	voiceMinMonthly: "Voice minutes per month",
	chatUsdDaily: "Chat dollars per day (US$)",
	chatUsdMonthly: "Chat dollars per month (US$)",
	voiceUsdDaily: "Voice dollars per day (US$)",
	voiceUsdMonthly: "Voice dollars per month (US$)",
};

export const assistantUsageTexts = { id, en } as const;
